'use strict';

module.exports = {
    onPurchase: 'onPurchase',
    handInCoupon: 'handInCoupon',
};
